import jwtActionTypes from '../actions/jwt/jwt-action-types';

const initialState = {
  token: null, 
};

const jwt = (state = initialState, action) => {
  if (action.type === jwtActionTypes.JWT_TOKEN) {
    return {
      ...state,
      token: action.payload,
    };
  } else {
    return state;
  }
};

export default jwt;
